import api from 'service/api'

const dponetAPI = api.create('dponet')

const show = async () => {
  return await dponetAPI.get('/tickets/evaluation_setting')
}

const evaluationSetting = {
  show,
}

export default evaluationSetting
